// SIWS CUSTOM 2026-06-03 Essential Race Tee rebuild — Camo Route Classics /
// Rally Shirts pattern (corrected from initial Metal Tee misbuild).
//
// Single-design, 8-size (XS..4XL) pre-order tee. Size-pill selection model:
//   1. Dealer clicks one size pill — selectPill() marks aria-pressed + sets the
//      hidden id input from data-variant-id.
//   2. Shared qty stepper edits the quantity (min 1, no max — pre-order has no
//      inventory cap).
//   3. ATC submit POSTs ONE /cart/add.js line { id: selectedVariantId, quantity }
//      with Section Rendering API hints so Dawn's cart-notification/drawer can
//      re-render inline (no PDP redirect).
//   4. resetAfterAdd() clears the selection + restores qty to 1 so the dealer
//      can add another size with another click.
//
// Adapted from the inline IIFE in sections/rally-leftover-product.liquid.
// Differences vs that source:
//   - Module-style: scans for [data-essential-tee-form] elements and inits each,
//     instead of being scoped to one section.id at compile time.
//   - Strips inventory tracking entirely (no data-inventory, no getMaxQty,
//     no reconcilePillAvailability) — pre-order has no stock to enforce.
//   - Strips Bundle pill / Bundle group logic — single-design product.
//   - Strips mixed-cart guard (window.__siwsLastAddIntent) — irrelevant here.
//   - Keeps: selectPill, resetAfterAdd, submitCart, hydrateCart, renderCartBlock,
//     renderSummary, renderAtcLabel, renderAtcState, renderStepButtons.

'use strict';

(function () {
  function formatMoney(cents) {
    return '$' + (Number(cents) / 100).toFixed(2);
  }

  function escapeHtml(s) {
    return String(s || '').replace(/[<>&"]/g, function (c) {
      return ({ '<': '&lt;', '>': '&gt;', '&': '&amp;', '"': '&quot;' })[c];
    });
  }

  function initForm(form) {
    var pills      = form.querySelectorAll('.siws-pdp-size-pill');
    var idInput    = form.querySelector('[data-et-variant-id]');
    var qtyInput   = form.querySelector('[data-et-qty]');
    var stepDec    = form.querySelector('[data-et-step="-1"]');
    var stepInc    = form.querySelector('[data-et-step="1"]');
    var summaryEl  = form.querySelector('[data-et-summary]');
    var atc        = form.querySelector('[data-et-atc]');
    var errorEl    = form.querySelector('[data-et-error]');
    var productIdEl = form.querySelector('[data-et-product-id]');
    var stockEl    = form.querySelector('[data-et-stock]');

    if (!pills.length || !idInput || !qtyInput || !atc || !summaryEl) {
      console.warn('[essential-race-tee] missing required DOM nodes on form', form);
      return;
    }

    var productId = productIdEl ? parseInt(productIdEl.value, 10) : null;

    var selectedPill = null;
    // SIWS: cache of cart line items belonging to THIS product (filter by
    // product_id). Hydrated from /cart.js on init + after cartUpdate events
    // so the "Already in Your Cart" sub-block survives every renderSummary wipe.
    var cachedItems = [];

    function readQty() {
      var qty = parseInt(qtyInput.value, 10);
      if (!Number.isFinite(qty) || qty < 1) qty = 1;
      return qty;
    }

    function getMaxQty() {
      var m = parseInt(qtyInput.max, 10);
      return Number.isFinite(m) && m > 0 ? m : Infinity;
    }

    function applyInventoryFromPill(pill) {
      var invMgmt = pill.getAttribute('data-inventory-management') || '';
      var invRaw  = pill.getAttribute('data-inventory');
      var inv     = invRaw == null || invRaw === '' ? NaN : parseInt(invRaw, 10);
      if (invMgmt === 'shopify' && Number.isFinite(inv)) {
        qtyInput.max = inv;
        if (readQty() > inv) qtyInput.value = Math.max(1, inv);
        if (stockEl) {
          if (inv > 0) {
            stockEl.textContent = inv + ' left';
            stockEl.hidden = false;
          } else {
            stockEl.textContent = '';
            stockEl.hidden = true;
          }
        }
      } else {
        qtyInput.removeAttribute('max');
        if (stockEl) {
          stockEl.textContent = '';
          stockEl.hidden = true;
        }
      }
    }

    function clearInventoryDisplay() {
      qtyInput.removeAttribute('max');
      if (stockEl) {
        stockEl.textContent = '';
        stockEl.hidden = true;
      }
    }

    function showError(text) {
      if (!errorEl) return;
      if (text) {
        errorEl.textContent = text;
        errorEl.hidden = false;
      } else {
        errorEl.textContent = '';
        errorEl.hidden = true;
      }
    }

    function renderSummary() {
      var inner;
      if (!selectedPill) {
        inner =
          '<h4 class="siws-cal-order-summary__title">Adding to Cart</h4>' +
          '<p class="siws-cal-order-summary__empty">Select a size to begin your order.</p>';
      } else {
        var price = parseInt(selectedPill.getAttribute('data-price'), 10) || 0;
        var title = selectedPill.getAttribute('data-title') || '';
        var qty   = readQty();
        var sub   = price * qty;
        inner =
          '<h4 class="siws-cal-order-summary__title">Adding to Cart</h4>' +
          '<table class="siws-cal-order-summary__table">' +
            '<tbody>' +
              '<tr>' +
                '<td>' + escapeHtml(title) + '</td>' +
                '<td class="siws-cal-order-summary__qty-cell">' +
                  qty + ' &times; ' + formatMoney(price) + ' = ' + formatMoney(sub) +
                '</td>' +
              '</tr>' +
            '</tbody>' +
            '<tfoot>' +
              '<tr class="siws-cal-order-summary__total-row">' +
                '<td>Total</td>' +
                '<td class="siws-cal-order-summary__qty-cell">' + formatMoney(sub) + '</td>' +
              '</tr>' +
            '</tfoot>' +
          '</table>';
      }
      summaryEl.innerHTML = inner;
      // Re-prepend cached "Already in Your Cart" block (innerHTML above wiped it).
      renderCartBlock(cachedItems);
    }

    function renderCartBlock(items) {
      var existing = summaryEl.querySelector('.siws-cal-cart-block');
      if (!items || items.length === 0) {
        if (existing) existing.remove();
        return;
      }
      var usd = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });
      var subtotalCents = items.reduce(function (sum, i) {
        return sum + (i.final_line_price || i.line_price || 0);
      }, 0);
      var linesHtml = items.map(function (i) {
        var label     = i.variant_title || i.title || '';
        var unitCents = i.final_price || i.price || 0;
        var lineCents = i.final_line_price || i.line_price || 0;
        return '<tr>' +
          '<td>' + escapeHtml(label) + '</td>' +
          '<td class="siws-cal-order-summary__qty-cell">' +
            i.quantity + ' &times; ' + usd.format(unitCents / 100) +
            ' = ' + usd.format(lineCents / 100) +
          '</td>' +
        '</tr>';
      }).join('');
      var blockHtml =
        '<div class="siws-cal-cart-block">' +
          '<h3 class="siws-cal-cart-block__heading">Already in Your Cart</h3>' +
          '<table class="siws-cal-order-summary__table">' +
            '<tbody>' + linesHtml + '</tbody>' +
            '<tfoot>' +
              '<tr class="siws-cal-order-summary__total-row">' +
                '<td>Subtotal</td>' +
                '<td class="siws-cal-order-summary__qty-cell">' + usd.format(subtotalCents / 100) + '</td>' +
              '</tr>' +
            '</tfoot>' +
          '</table>' +
        '</div>';
      if (existing) {
        existing.outerHTML = blockHtml;
      } else {
        summaryEl.insertAdjacentHTML('afterbegin', blockHtml);
      }
    }

    async function hydrateCart() {
      if (productId == null) return;
      try {
        var res = await fetch('/cart.js');
        if (!res.ok) return;
        var cart = await res.json();
        cachedItems = (cart.items || []).filter(function (i) {
          return i.product_id === productId;
        });
      } catch (err) {
        cachedItems = [];
        return;
      }
      renderCartBlock(cachedItems);
    }

    function renderAtcLabel() {
      if (!selectedPill) {
        atc.textContent = 'Add to Cart';
        return;
      }
      var qty   = readQty();
      var price = parseInt(selectedPill.getAttribute('data-price'), 10) || 0;
      atc.textContent = 'Add ' + qty + ' to Cart — ' + formatMoney(price * qty);
    }

    function renderAtcState() {
      atc.disabled = !selectedPill || readQty() < 1;
    }

    function renderStepButtons() {
      var qty = readQty();
      var max = getMaxQty();
      if (stepDec) stepDec.disabled = !selectedPill || qty <= 1;
      if (stepInc) stepInc.disabled = !selectedPill || qty >= max;
      qtyInput.disabled = !selectedPill;
    }

    function renderAll() {
      renderSummary();
      renderAtcLabel();
      renderAtcState();
      renderStepButtons();
    }

    function selectPill(pill) {
      // Defensive: clear aria-pressed on ALL pills.
      for (var i = 0; i < pills.length; i++) {
        pills[i].setAttribute('aria-pressed', 'false');
      }
      selectedPill = pill;
      pill.setAttribute('aria-pressed', 'true');
      idInput.value = pill.getAttribute('data-variant-id') || '';
      qtyInput.value = 1;
      applyInventoryFromPill(pill);
      showError('');
      renderAll();
    }

    function resetAfterAdd() {
      for (var i = 0; i < pills.length; i++) {
        pills[i].setAttribute('aria-pressed', 'false');
      }
      selectedPill = null;
      idInput.value = '';
      qtyInput.value = 1;
      clearInventoryDisplay();
      renderAll();
    }

    async function submitCart(e) {
      if (e) e.preventDefault();
      if (!selectedPill || atc.disabled) return;
      var variantId = parseInt(selectedPill.getAttribute('data-variant-id'), 10);
      var qty       = readQty();
      if (!Number.isFinite(variantId) || qty < 1) return;

      var originalLabel = atc.textContent;
      atc.disabled = true;
      atc.textContent = 'Adding…';
      showError('');

      try {
        var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        var sections = cart && typeof cart.getSectionsToRender === 'function'
          ? cart.getSectionsToRender().map(function (s) { return s.id; })
          : ['cart-icon-bubble'];
        var body = {
          items:        [{ id: variantId, quantity: qty }],
          sections:     sections,
          sections_url: window.location.pathname,
        };

        var res = await fetch('/cart/add.js', {
          method:  'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body:    JSON.stringify(body),
        });
        if (!res.ok) {
          var errPayload = await res.json().catch(function () { return {}; });
          throw new Error(errPayload.description || errPayload.message || 'Could not add to cart.');
        }
        var payload = await res.json();

        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'siws-essential-tee', cartData: payload });
        }

        if (cart && typeof cart.renderContents === 'function') {
          cart.renderContents(payload); // opens drawer/notification
        } else {
          // Page-mode fallback — refresh cart-icon-bubble HTML in place.
          var newBubbleHTML = payload.sections && payload.sections['cart-icon-bubble'];
          var liveBubble = document.getElementById('cart-icon-bubble');
          if (newBubbleHTML && liveBubble) {
            var parsed = new DOMParser().parseFromString(newBubbleHTML, 'text/html');
            var inner  = parsed.querySelector('.shopify-section');
            if (inner) liveBubble.innerHTML = inner.innerHTML;
          }
        }

        // Await hydrate so resetAfterAdd's renderSummary uses fresh cachedItems
        // and the "Already in Your Cart" block reflects this add immediately.
        await hydrateCart();

        resetAfterAdd();
      } catch (err) {
        showError(err && err.message ? err.message : 'Could not add to cart.');
        atc.disabled    = false;
        atc.textContent = originalLabel;
      }
    }

    // Pill click handlers.
    for (var i = 0; i < pills.length; i++) {
      (function (p) {
        p.addEventListener('click', function () { selectPill(p); });
      })(pills[i]);
    }

    qtyInput.addEventListener('input', function () {
      var max = getMaxQty();
      if (readQty() > max) qtyInput.value = max;
      renderAll();
    });
    qtyInput.addEventListener('blur', function () {
      qtyInput.value = Math.min(readQty(), getMaxQty());
      renderAll();
    });

    if (stepDec) {
      stepDec.addEventListener('click', function () {
        qtyInput.value = Math.max(1, readQty() - 1);
        renderAll();
      });
    }
    if (stepInc) {
      stepInc.addEventListener('click', function () {
        qtyInput.value = Math.min(getMaxQty(), readQty() + 1);
        renderAll();
      });
    }

    form.addEventListener('submit', submitCart);

    renderAll();
    hydrateCart();

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () { hydrateCart(); });
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    var forms = document.querySelectorAll('[data-essential-tee-form]');
    forms.forEach(initForm);
  });
})();
